<div class="media-backdrop" *ngIf="show">
    <div class="close-button" (click)="close()"><img src="../../../assets/images/Cancel.svg" alt="" srcset=""></div>
    <div class="media-container">
        <div class="left" (click)="previous()" *ngIf="images.length > 1"></div>

        <div class="media-content">
            <ng-container *ngIf="isVideo(currentMedia)">
                <video [src]="currentMedia.video" controls autoplay></video>
            </ng-container>
            <ng-container *ngIf="isImage(currentMedia)">
                <img [src]="currentMedia.image" />
            </ng-container>
        </div>

        <div class="right" (click)="next()" *ngIf="images.length > 1"></div>

    </div>
</div>
